import { useState } from "react";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";

export const Testimonials = ({ testimonials = [] }) => {
  const [index, setIndex] = useState(0);
  if (!testimonials.length) return null;
  const t = testimonials[index];
  const go = (dir) => setIndex((i) => (i + dir + testimonials.length) % testimonials.length);

  return (
    <section className="section-py bg-[color:var(--bp-bg-2)]" data-testid="testimonials-carousel">
      <div className="container-bp">
        <SectionHeading eyebrow="In their words" title="Partners, not vendors." />

        <Reveal>
          <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr_auto]">
            <div className="relative rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-8 sm:p-12">
              <Quote className="h-9 w-9 text-[color:var(--bp-gold)]/60" />
              <blockquote key={t.id} className="mt-6 font-display text-2xl font-medium leading-[1.4] text-[color:var(--bp-cream)] sm:text-[1.7rem]">
                “{t.quote}”
              </blockquote>
              <div className="mt-8 flex items-center justify-between">
                <div>
                  <p className="text-[15px] font-semibold text-[color:var(--bp-cream)]">{t.name}</p>
                  <p className="text-[13px] text-[color:var(--bp-text-muted)]">{t.title} · {t.company}</p>
                </div>
                <span className="hidden rounded-full border border-[color:var(--bp-teal)]/40 bg-[color:var(--bp-teal-soft)] px-3 py-1 text-[11px] font-medium uppercase tracking-[0.12em] text-[color:var(--bp-teal)] sm:inline-block">
                  {t.market}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-3 lg:flex-col">
              <button onClick={() => go(-1)} data-testid="testimonials-prev-button" aria-label="Previous testimonial" className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[color:var(--bp-border)] text-[color:var(--bp-cream)] transition-colors hover:border-[color:var(--bp-teal)] hover:text-[color:var(--bp-teal)]">
                <ArrowLeft className="h-5 w-5" />
              </button>
              <span className="text-[12px] tabular-nums text-[color:var(--bp-text-muted)]">{String(index + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}</span>
              <button onClick={() => go(1)} data-testid="testimonials-next-button" aria-label="Next testimonial" className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[color:var(--bp-border)] text-[color:var(--bp-cream)] transition-colors hover:border-[color:var(--bp-teal)] hover:text-[color:var(--bp-teal)]">
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
